import { connect } from 'react-redux';
import { BrokerComponent } from './BrokerComponent'

const mapStateToProps = (state: any): any => {
	return {
	}
}

const mapDispatchToProps: any = {
}

export const BrokerContainer = connect(mapStateToProps, mapDispatchToProps)(BrokerComponent)
